/* eslint-disable react/forbid-dom-props */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

/** @namespace Theme/Component/UserIcon/Component */
export class UserIconComponent extends PureComponent {
    static propTypes = {
        isActive: PropTypes.bool,
    };

    static defaultProps = {
        isActive: false,
    };

    render() {
        const { isActive } = this.props;

        return (
            <svg
              block="UserIcon"
              mods={ { isActive } }
              width="25"
              height="30"
              viewBox="0 0 25 30"
              xmlns="http://www.w3.org/2000/svg"
            >
                <g transform="translate(0)">
                    <rect className="a" fill="#00c7fe" width="3.115" height="3.053" transform="translate(0 26.293)" />
                    <path
                      className="b"
                      fill="#fff"
                      d="M28.672,28.231a12.336,12.336,0,0,0-9.56-11.38,7.71,7.71,0,1,0-5.659,0A12.336,12.336,0,0,0,4,26.8H7.084a9.36,9.36,0,0,1,18.5,1.434H8.626v3.084H28.672V28.231ZM11.71,9.634a4.626,4.626,0,1,1,4.626,4.626A4.626,4.626,0,0,1,11.71,9.634Z"
                      transform="translate(-4 -1.969)"
                    />
                </g>
            </svg>
        );
    }
}

export default UserIconComponent;
